import React, { useEffect, useState } from 'react';
import { Form, FormGroup, Input, Label, Row, Col, Modal, ModalHeader, ModalBody } from 'reactstrap';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useForm from '../CustomHooks/useForm';

const useStyles = makeStyles((theme) => ({
  dialog: {
    '& .MuiDialog-paper': {
      background: theme.palette.type === 'dark' ? theme.palette.background.paper : 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(10px)',
      borderRadius: 12,
      border: '1px solid rgba(255, 255, 255, 0.2)',
      boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)',
      minWidth: 500,
    },
  },
  dialogTitle: {
    background: 'linear-gradient(135deg, #0a1e42 0%, #0b5fad 50%, #3a8ac4 100%)',
    color: 'white',
    padding: '16px 24px',
    textAlign: 'center',
    margin: 0,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: 'white',
  },
  modalBody: {
    padding: theme.spacing(4),
    textAlign: 'center',
  },
  checkboxArea: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    background: 'rgba(0, 85, 162, 0.05)',
    borderRadius: 8,
  },
  deleteButton: {
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 600,
    fontSize: '0.9rem',
    textTransform: 'none',
    backgroundColor: '#c62828',
    color: '#fff',
    padding: theme.spacing(1.5),
    borderRadius: 8,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#8e0000',
      boxShadow: 'none',
    },
    '&.Mui-disabled': {
      backgroundColor: 'rgba(0, 0, 0, 0.12)',
      color: 'rgba(0, 0, 0, 0.26)',
    },
  },
}));

const UserDeleteCheckModal = (props) => {
  const classes = useStyles();

  const preferredLanguage = props.preferredLanguage
  const getTranslation = props.getTranslation

  const DialogTitle = (props) => {
    const { children, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.dialogTitle} style={{ position: 'relative' }} {...other}>
        <Typography variant="h6" style={{ color: 'white', fontFamily: 'Montserrat, sans-serif', fontWeight: 700 }}>
          {children}
        </Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  };

  return (
    <div>
      <Dialog
        className={classes.dialog}
        onClose={props.toggle}
        aria-labelledby="customized-dialog-title"
        open={props.isOpen}
      >
        <DialogTitle id="customized-dialog-title" onClose={props.toggle}>
          {getTranslation("Are you sure?", preferredLanguage)}
        </DialogTitle>

        <div className={classes.modalBody}>
          {props.displayCannotDeleteYourselfMessage()}
          {props.displayCannotDeleteOnlyAdminMessage()}

          <div className={classes.checkboxArea}>
            <FormGroup check>
              <input
                check
                style={{ marginLeft: '10px', cursor: 'pointer' }}
                type="checkbox"
                checked={props.isUserDeleteChecked}
                onClick={() => props.setIsUserDeleteChecked(!props.isUserDeleteChecked)}
              ></input>
              <Label check style={{ fontSize: '16px', marginLeft: '12px', padding: '10px', fontFamily: 'Montserrat, sans-serif' }} for="confirmDeleteCheck">
                {getTranslation("Yes, I want to delete these users.", preferredLanguage)}
              </Label>
            </FormGroup>
          </div>

          <Button
            disabled={!props.isUserDeleteChecked}
            onClick={props.handleDeletion}
            id="deleteAllSelected"
            fullWidth
            variant="contained"
            className={classes.deleteButton}
          >
            {getTranslation("Delete Selected", preferredLanguage)}
          </Button>
        </div>
      </Dialog>
    </div>
  );
};
export default UserDeleteCheckModal;
